import { escapeRegexSpecialCharacters } from 'helpers/highlightWords'

export const suggestionRequestObject = input => {
  const MIN_INPUT_REQUIRED_LENGTH = 2
  input = input.trim()

  return {
    value: input,
    escapedValue: escapeRegexSpecialCharacters(input),
    isValid: !!input && input.length > MIN_INPUT_REQUIRED_LENGTH,
    isInitialSearch: !!input && input.length == MIN_INPUT_REQUIRED_LENGTH + 1,
  }
}

export default {
  suggestionRequestObject,
}
